import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transformation-api-settings',
  templateUrl: './transformation-api-settings.component.html',
  styleUrls: ['./transformation-api-settings.component.scss']
})
export class TransformationApiSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
